export default function PHP_zip_entry_read() {
  return (
    <div>
      <h1>PHP_zip_entry_read</h1>
    </div>
  );
}
